import { useIsSubmitting } from "remix-validated-form";
import { classNames } from "~/utils";

export default ({className, submit, submitting, ref}) => {
    const isSubmitting = useIsSubmitting();
    return (
        <button type="submit" disabled={isSubmitting}
            ref={ref}
            className={classNames("inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-pcolor-400 hover:bg-pcolor-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pcolor-400", className)}>
            {isSubmitting ? (submitting || "Submitting") : (submit || "Submit")}
        </button>
    );
};